import type { ReceiptItem } from "@nmt/shared";
import { Badge, formatDate } from "./ui";

/**
 * Whether a receipt is paid. An expense (check, card, cash) was paid when it was made, so it always
 * says Paid, with how; a vendor credit or refund is a Credit; a bill is Paid once it's paid.
 */
export function PaidBadge({ r, kind, withDate }: { r: Pick<ReceiptItem, "kind" | "paymentMethod" | "cardLast4" | "qbPaidAt">; kind?: ReceiptItem["kind"]; withDate?: boolean }) {
  const k = kind ?? r.kind;
  if (k === "credit") return <Badge tone="off">Credit</Badge>;
  if (k === "expense") {
    const how = [r.paymentMethod, r.paymentMethod === "Company card" && r.cardLast4 ? `…${r.cardLast4}` : ""].filter(Boolean).join(" ");
    return <Badge tone="ok">{how ? `Paid · ${how}` : "Paid"}</Badge>;
  }
  return r.qbPaidAt ? <Badge tone="ok">{withDate ? `Paid ${formatDate(r.qbPaidAt)}` : "Paid"}</Badge> : null;
}
